module.exports = {
  selectLanguage: "Select your language",
  paintSize: "Size",
  paintYear: "Year",
  paintMethod: "Method",
  loadMore: "Load more",
  backlink: "Back",
  filterValueAll: "all",
  filterFrom: "from",
  authorName: "Viktor",
  authorSurame: "Vynogradov",
  authorFullname: "Viktor Vynogradov",
  seoDescr: "Viktor Vynogradov is an outstanding Ukrainian artist and writer",
  seoDescr2: "Buy picture of Vinogradov",
  btnAddCart: "Buy it",
  btnRemoveFromCart: "Remove from cart",
  btnReserCart: "Clear all",
  isOrderSentFailed: "Clear all",
  isOrderSentFailed: "Clear all",
  yourName: "your name",
  yourEmail: "your email",
}
